import React from 'react';

function Logo({ small = false, className = '' }) {
  return (
    <img
      src="/logo.png"
      alt="Adhunik Prefab Systems"
      className={`brand-logo-img ${small ? 'brand-logo-img--small' : ''} ${className}`.trim()}
    />
  );
}

export default Logo;
